document.addEventListener('DOMContentLoaded', function() {
  var sticky = document.querySelector('.product-single__sticky');
  if (!sticky) return;
  if (window.innerWidth < 990) return;

  var container = sticky.closest('.grid--product-images--partial');
  var stickyWidth = sticky.offsetWidth;
  var stickyLeft = sticky.getBoundingClientRect().left;
  var topOffset = 40;

  var placeholder = document.createElement('div');
  placeholder.style.width = stickyWidth + 'px';
  placeholder.style.flexShrink = '0';
  placeholder.style.display = 'block';
  container.insertBefore(placeholder, sticky);

  sticky.style.position = 'absolute';
  sticky.style.top = topOffset + 'px';
  sticky.style.width = stickyWidth + 'px';

  function updateSticky() {
    var containerRect = container.getBoundingClientRect();
    var stickyHeight = sticky.offsetHeight;

    // Container deve ter altura mínima = imagem + offset do topo
    container.style.minHeight = (stickyHeight + topOffset) + 'px';

    var maxTop = container.offsetHeight - stickyHeight;

    if (containerRect.top <= topOffset && containerRect.bottom >= stickyHeight + topOffset) {
      sticky.style.position = 'fixed';
      sticky.style.top = topOffset + 'px';
      sticky.style.left = stickyLeft + 'px';
      sticky.style.width = stickyWidth + 'px';
      sticky.style.margin = '0';
    } else if (containerRect.bottom < stickyHeight + topOffset) {
      sticky.style.position = 'absolute';
      sticky.style.top = maxTop + 'px';
      sticky.style.left = '0';
      sticky.style.width = stickyWidth + 'px';
      sticky.style.margin = '0';
    } else {
      sticky.style.position = 'absolute';
      sticky.style.top = topOffset + 'px';
      sticky.style.left = '0';
      sticky.style.width = stickyWidth + 'px';
      sticky.style.margin = '0';
    }
  }

  document.addEventListener('scroll', updateSticky, { passive: true });

  window.addEventListener('resize', function() {
    sticky.style.position = 'absolute';
    sticky.style.top = topOffset + 'px';
    stickyWidth = sticky.offsetWidth;
    stickyLeft = sticky.getBoundingClientRect().left;
    placeholder.style.width = stickyWidth + 'px';
    sticky.style.width = stickyWidth + 'px';
    updateSticky();
  });

  updateSticky();
});
